import React, { useEffect, useState } from "react";
import { Modal, Button, Checkbox, Text, Group } from "@mantine/core";
import fetchApi from "../components/Lib/api";

function TermsPopup({ user }) {
  const [opened, setOpened] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpened(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleAccept = async () => {
    if (agreed) {
      setIsSubmitting(true);
      try {
        const response = await fetchApi("/api/users/accept_terms_and_conditions", "PUT");
        if (response.ok) {
          setOpened(false); // Close modal only on successful acceptance
        }
      } catch (error) {
        console.error("Error in accepting terms", error);
        // Consider adding user feedback for errors
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {}} // Do nothing on close attempts
        withCloseButton={false} // Remove the close button
        closeOnClickOutside={false} // Prevent closing by clicking outside
        closeOnEscape={false} // Prevent closing with the Escape key
        title={<Text size="xl" weight={700}>Terms and Conditions</Text>}
        overlayProps={{
          backgroundOpacity: 0.65,
          blur: 4,
        }}
        yOffset={80}
        styles={{
          title: {
            fontWeight: 700,
            color: '#1a73e8',
          },
          modal: {
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          },
          body: {
            padding: '20px',
          }
        }}
      >
        <Text size="sm" style={{ lineHeight: 1.6, marginBottom: 15 }}>
          Please review and accept our Privacy Policy and Terms & Conditions
          before continuing to use our services.
        </Text>

        <Checkbox
          mt="md"
          mb="md"
          checked={agreed}
          onChange={(event) => setAgreed(event.currentTarget.checked)}
          styles={{
            label: {
              fontSize: '0.9rem', 
              lineHeight: 1.5,
            },
            input: {
              cursor: 'pointer',
            }
          }}
          label={
            <>
              I agree to the{" "}
              <a
                href="https://app.termly.io/policy-viewer/policy.html?policyUUID=01c438e7-38aa-4cd2-b502-074c52d0d640"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1a73e8", fontWeight: 500, textDecoration: "underline" }}
              >
                Terms and Conditions
              </a>{" "}
              and{" "}
              <a
                href="https://app.termly.io/policy-viewer/policy.html?policyUUID=4283ca3d-0ece-436e-a607-3cad4a5df659"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1a73e8", fontWeight: 500, textDecoration: "underline" }}
              >
                Privacy Policy
              </a>
            </>
          }
        />

        <Group mt="xl" position="right">
          <Button
            disabled={!agreed}
            onClick={handleAccept}
            loading={isSubmitting}
            styles={{
              root: {
                backgroundColor: agreed ? '#1a73e8' : undefined,
                '&:hover': {
                  backgroundColor: agreed ? '#1565c0' : undefined,
                }
              }
            }}
          >
            {isSubmitting ? 'Processing...' : 'Accept'}
          </Button>
        </Group>
      </Modal>
    </>
  );
}

export default TermsPopup;